'use client';
import React from 'react';

interface EmptyStateCardProps {
  activeTab: 1 | 2;
  onSwitchTab: () => void;
  isFiltered?: boolean;
}

export default function EmptyStateCard({
  onSwitchTab,
  isFiltered = false,
}: Omit<EmptyStateCardProps, 'activeTab'>) {
  const icon = isFiltered ? (
    // Filter / search icon
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-primary/50"
      aria-hidden="true"
    >
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ) : (
    // Empty list icon
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="text-primary/50"
      aria-hidden="true"
    >
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <line x1="9" y1="9" x2="15" y2="9" />
      <line x1="9" y1="12" x2="12" y2="12" />
    </svg>
  );

  const title = isFiltered
    ? 'Không có kết quả khớp bộ lọc'
    : 'Danh sách ID tạm thời trống';

  const message = isFiltered
    ? 'Thử bỏ bộ lọc khu vực hoặc trạng thái để xem thêm tài khoản.'
    : 'Hệ thống đang được cập nhật dữ liệu. Vui lòng quay lại sau ít phút để lấy ID mới nhất.';

  return (
    <div className="bg-soft border-2 border-dashed border-border rounded-2xl px-6 py-10 text-center flex flex-col items-center gap-4">
      {/* Icon circle */}
      <div className="w-16 h-16 rounded-full bg-white border border-border flex items-center justify-center shadow-card">
        {icon}
      </div>

      {/* Text */}
      <div className="space-y-1.5 max-w-sm">
        <h3 className="font-semibold text-foreground text-[15px]">{title}</h3>
        <p className="text-[13px] text-muted leading-relaxed">{message}</p>
      </div>

      {/* Actions */}
      <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto justify-center mt-1">
        {isFiltered ? (
          <button
            onClick={onSwitchTab}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-pill text-white font-semibold cta-gradient shadow-soft min-h-[44px] hover:opacity-90 active:scale-95 transition-all text-sm"
          >
            Xóa tất cả bộ lọc
          </button>
        ) : (
          <button
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-pill text-white font-semibold cta-gradient shadow-soft min-h-[44px] hover:opacity-90 active:scale-95 transition-all text-sm"
          >
            Làm mới trang
          </button>
        )}
      </div>

      {/* Hint */}
      <p className="text-[11px] text-muted/70">
        Dữ liệu được cập nhật tự động mỗi ngày
      </p>
    </div>
  );
}